import { PopUp } from './PopUp.tsx'; 

export const GameWon = ({ onClick=()=>{} }) => {
  return <>
  <PopUp className="you-won" onClick={onClick}>
    <p>You won! You have discovered the true purpose of the machine and can now train it yourself. Or try to convince others in Fango you know all about it...</p>
    <p><span style={{fontStyle: 'italic'}}>Fango 1000</span> is a prototype of a <a href="https://aw.network/posts/large-lore-models" target="_blank" rel="noopener noreferrer">Large Lore Model</a>, a tool hypothesised by dmstfctn, Eva Jäger and Alasdair Milne to connect existing onchain data with user stories and perspectives. The chronicles in Fango 1000 contain a historical record of actions generated by players of dmstfctn's AI training game Godmode Epochs (2023), which are here turned into material to use for stories.</p>
  </PopUp>  
  </>
}